import { PrettyPrinter } from '../pretty-printer.service';

import * as showdown from 'assets/vendor/showdown/showdown.min.js';
import { alertExt, calloutExt, prettifyExt } from './extensions';

type Converter = { makeHtml: (text: string) => string, addExtension(ext: () => void, name: string) };

let ShowdownConverter: Converter;

export class ShowdownService {
	private prettyPrinterService = new PrettyPrinter();

	public convertToHtml(text: string) {
		if (!text || !text.trim()) {
			return '';
		}

		return  this.getShowdownConverter().makeHtml(text);
	}

	private getShowdownConverter(): Converter {
		if (ShowdownConverter) {
			return ShowdownConverter;
		}

		// get prettify instance in order to inject in inside extension since is lazy loaded
		ShowdownConverter = new showdown.Converter({openLinksInNewWindow: true});

		ShowdownConverter.addExtension(calloutExt, 'codeExample');
		ShowdownConverter.addExtension(prettifyExt(this.prettyPrinterService.getPrettyPrintOne()), 'prettify');
		ShowdownConverter.addExtension(alertExt, 'alert');

		return ShowdownConverter;
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/helpers/showdown/showdown.service.ts